function marginTop() {
  var navHeight = $('nav').height();
  $('#content').css('margin-top', navHeight);
}

// Scroll parrallax
function react_to_window() {

  if ($(window).width() >= 900) {
    $(window).stellar({
      horizontalScrolling: false,
      verticalOffset: 400
    });
  }
}

$(document).ready(function(){
    // margin top nav
    marginTop();

    // Mobile Menu
    $('#toggle').click(function() {
       $(this).toggleClass('active');
       $('#overlay').toggleClass('open');
       $('body').toggleClass('fixed');
    });

    // Slider
    $(".royalSlider").royalSlider({
    		autoPlay: {
	    		enabled: true,
	    		delay: 5000,
	    		stopAtAction: false,
	    		pauseOnHover: false
	    	},
	    	block: {
	    		// animated blocks options go gere
	    		fadeEffect: false,
	    		moveEffect: 'left'
	    	},
        autoHeight: false,
        navigateByClick: true,
        arrowsNav: true,
        fadeinLoadedSlide: true,
        controlNavigationSpacing: 0,
        imageScaleMode: 'fill',
        controlNavigation: 'none',
        imageAlignCenter: true,
        loop: true,
        keyboardNavEnabled: true,
        arrowsNavAutoHide: false
    });

  	// Scroll reveal
  	if ($(window).width() > 767) {
		  window.sr = ScrollReveal();
		  sr.reveal('.appear_bottom', {
		    duration: 2000,
		    origin: 'bottom',
		    distance: '150px',
		    scale: 0
		  },100);

		  sr.reveal('.appear_bottom2', {
		    duration: 2000,
		    origin: 'bottom',
		    distance: '150px',
		    scale: 0
		  },100);

		  sr.reveal('.appear_bottom3', {
		    duration: 2000,
		    origin: 'bottom',
		    distance: '150px',
		    scale: 0
		  },100);

		  sr.reveal('.appear_bottom_solo', {
		    duration: 2000,
		    origin: 'bottom',
		    distance: '150px',
		    scale: 0
		  });

		  sr.reveal('.fadein', {
		    duration: 2000,
		    origin: 'bottom',
		    distance: '0px',
		    scale: 0
		  });

		  sr.reveal('.appear_left', {
		    duration: 2000,
		    origin: 'left',
		    distance: '250px',
		    scale: 0
		  });

		  sr.reveal('.appear_right', {
		    duration: 2000,
		    origin: 'right',
		    distance: '250px',
		    scale: 0
		  });
		}

		// MENU ACTIVE
    if($("#single_cours").length > 0 ) {
        $('#menu-header-menu li').removeClass('active');
        $('#menu-header-menu li:nth-child(2)').addClass('active');
    } else if($("#single_stages").length > 0 ) {
        $('#menu-header-menu li').removeClass('active');
        $('#menu-header-menu li:nth-child(3)').addClass('active');
    } else if($("#single_animations").length > 0 ) {
        $('#menu-header-menu li').removeClass('active');
        $('#menu-header-menu li:nth-child(4)').addClass('active');
    } else if($("#single_inscriptions").length > 0 ) {
        $('#menu-header-menu li').removeClass('active');
        $('#menu-header-menu li:nth-child(5)').addClass('active');
    }
});

$(window).resize(function() {
    // margin top nav
    marginTop();
});

$( window ).scroll(function() {
    // Sticky header
    if ($(window).width() > 767) {
      if ($(window).scrollTop() > 100){
        $('nav').addClass('sticky');
      } else {
        $('nav').removeClass('sticky');
      }
    }
});